var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("bottom: " + _vm.bottom + "px;")),attrs:{"id":"quickNav"},on:{"click":_vm.click}},[_c('i',{staticClass:"el-icon-bottom"})])}
var staticRenderFns = []

export { render, staticRenderFns }